export default "__VITE_ASSET__BssEY$x5__"